// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
    const url = process.env.REACT_APP_API_URL;
  return (
    <footer className="footer">
      <p>© 2025 Ming Dynasty. All rights reserved. API: {url}</p>

    </footer>
  );
}

export default Footer;
